import { configureStore } from '@reduxjs/toolkit';
import apiSlice from '../features/api/apiSlice';
import assignmentSliceReducer from '../features/assignment/assignmentSlice';
import authSliceReducer from '../features/auth/authSlice';
import quizSliceReducer from '../features/quiz/quizSlice';
import videosSliceReducer from '../features/videos/videosSlice';

export const store = configureStore({
  reducer: {
      [apiSlice.reducerPath]: apiSlice.reducer,
      auth: authSliceReducer,
      quiz: quizSliceReducer,
      video: videosSliceReducer,
      assignment: assignmentSliceReducer
  },
  devTools: process.env.NODE_ENV !== 'production',
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(apiSlice.middleware)
});


